import { AppBar, Toolbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import ChedarLogo from '../../../assets/images/ChedarOffline.png'
import { useNavigate } from 'react-router-dom'
import LanguageButton from './LanguageButton'
import LogOutButton from './LogOutButton'
import SearchBar from '../../ui/SearchBar/SearchBar'
import OnlineButton from './GridNavBar/OnlineButton'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  iconImage: {
    flexGrow: 1,
  },
  logoImage: {
    [theme.breakpoints.down('xs')]: {
      height: '1rem',
    },
  },
}))

function Navbar() {
  const classes = useStyles()
  const navigate = useNavigate()
  const userLoginStatus = useSelector(state => state.auth.userLoginStatus)
  const userInfo = useSelector(state => state.auth.userInfo)

  const navigateHome = () => {
    navigate(`/`)
  }

  return (
    <>
      <AppBar position='static'>
        <Toolbar variant='dense'>
          <div className={classes.iconImage}>
            <img
              src={ChedarLogo}
              alt='Chedar Logo'
              className={classes.logoImage}
              onClick={navigateHome}
            />
          </div>
          {userLoginStatus && Object.keys(userInfo).length !== 0 && <SearchBar />}
          <OnlineButton />
          <LanguageButton />
          <LogOutButton />
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Navbar
